import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  // These classes are used by CurrentLoanDetails.js
  detailsWrapper: {
    width: '100%',
    marginTop: '16px',
    marginBottom: '8px',
    [theme.breakpoints.down('xs')]: {
      marginTop: '12px',
      marginBottom: '4px',
    },
  },
  
  detailsContainer: {
    width: '100%',
    // backgroundColor: 'green',
    padding: '4px 0',
    [theme.breakpoints.down('sm')]: {
      width: '80% !important',
      padding: '0',

    },
  },

  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
    },
  },
  
  detailIcon: {
    maxWidth: '24px',
    height: 'auto',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '18px',
    },
  },

  keyContainer: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      // minWidth: '110px !important',
      // backgroundColor: '#F5F5F5',
    },
  },

  valueContainer: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      justifyContent: 'flex-end',
    },
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'flex-end',
    },
  },

  childrenContainer: {
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      justifyContent: 'flex-end',
    },
  },
  
  CustomTypoKey: {
    color: "#0f5cac",
    fontWeight: "700",
    // fontSize: "12px !important",
    // wordBreak: "break-word",
    whiteSpace: "normal", // Ensure text wraps normally
    overflow: "visible", // Don't hide overflow
    lineHeight: "1.2",
    hyphens: "auto", // Allow hyphenation for better word breaks
    [theme.breakpoints.down('sm')]: {
      fontSize: "11px !important",
      letterSpacing: "0.5px !important",
      wordBreak: "none",

    },
    [theme.breakpoints.down('xs')]: {
      fontSize: "10px !important",
      fontWeight: "700 !important",
      wordBreak: "none",
    }
  },

  CustomTypoValue: {
    color: "#5E5E5E",
    fontWeight: "700",
    fontSize: "14px",
    wordBreak: "break-word",
    textAlign: "left",
    [theme.breakpoints.down('sm')]: {
      fontSize: "12px !important",
      textAlign: "right",
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '10px !important',
      textAlign: "right",
    }
  },

}));
